import axios from "axios";
import apiURI from "./Api";

// Endpoints exclusivos dos canais de venda (/channel/{code}/...). Publicos: o comprador pode chegar sem conta
export default class ChannelService {
  constructor(code) {
    this.base = `${apiURI}/channel/${code}`;
  }

  async info() {
    const response = await axios.get(`${this.base}/info`);
    return response.data;
  }

  async categories() {
    const response = await axios.get(`${this.base}/categories`);
    return response.data;
  }

  async products({ category, q, page = 0, size = 24 } = {}) {
    const response = await axios.get(`${this.base}/products`, {
      params: { category: category || undefined, q: q || undefined, page, size },
    });
    return response.data;
  }

  async product(id) {
    const response = await axios.get(`${this.base}/products/${id}`);
    return response.data;
  }

  // items: [{ productId, variationId, quantity, shareToken }]
  async quote(items) {
    const response = await axios.post(`${this.base}/cart/quote`, { items });
    return response.data;
  }

  async createPaypalOrder(items) {
    const response = await axios.post(`${this.base}/paypal/create`, { items });
    return response.data;
  }

  // { paypalOrderId, buyer, address, latitude, longitude, utm }
  async checkout(payload) {
    const response = await axios.post(`${this.base}/checkout`, payload);
    return response.data;
  }

  /* ---------- adesao do vendedor (painel, autenticado) ---------- */

  auth() {
    return { headers: { Authorization: `Bearer ${localStorage.getItem("__extraconomy_token")}` } };
  }

  async sellerMe() {
    const response = await axios.get(`${this.base}/seller/me`, this.auth());
    return response.data;
  }

  async sellerJoin({ acceptTerms, allProducts }) {
    const response = await axios.post(`${this.base}/seller/join`, { acceptTerms, allProducts }, this.auth());
    return response.data;
  }

  async sellerLeave() {
    const response = await axios.post(`${this.base}/seller/leave`, {}, this.auth());
    return response.data;
  }

  async sellerProducts({ allProducts, productIds }) {
    const response = await axios.put(`${this.base}/seller/products`, { allProducts, productIds }, this.auth());
    return response.data;
  }

  /* ---------- admin do canal (somente Admin) ---------- */

  get adminBase() {
    return this.base.replace("/channel/", "/admin/channel/");
  }

  async adminConfig() {
    const response = await axios.get(`${this.adminBase}/config`, this.auth());
    return response.data;
  }

  // { active, cashbackPercent }
  async adminSaveConfig(config) {
    const response = await axios.put(`${this.adminBase}/config`, config, this.auth());
    return response.data;
  }

  async adminSellers() {
    const response = await axios.get(`${this.adminBase}/sellers`, this.auth());
    return response.data;
  }

  async adminSetSellerActive(id, active) {
    const response = await axios.put(`${this.adminBase}/sellers/${id}/active`, { active }, this.auth());
    return response.data;
  }

  // from/to: yyyy-MM-dd
  async adminCheckouts({ from, to } = {}) {
    const response = await axios.get(`${this.adminBase}/checkouts`, { ...this.auth(), params: { from, to } });
    return response.data;
  }

  async adminCashback({ from, to } = {}) {
    const response = await axios.get(`${this.adminBase}/cashback`, { ...this.auth(), params: { from, to } });
    return response.data;
  }

  async createPassword({ email, token, password }) {
    const response = await axios.post(`${this.base}/account/password`, { email, token, password });
    return response.data;
  }
}
